import { useEffect } from 'react';
import { onConsentChange, isConsentGranted } from '../lib/analytics';
import { initMetaPixel } from '../lib/metaPixel';

// Null component: subscribes to consent gate and loads Meta Pixel on first grant.
// Render once per app (alongside ConsentBanner). The underlying initMetaPixel
// is idempotent — additional renders do nothing.
export default function MetaPixel() {
  useEffect(() => {
    if (isConsentGranted()) {
      initMetaPixel();
    }
    return onConsentChange((granted) => {
      if (granted) initMetaPixel();
    });
  }, []);

  return null;
}
